import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { injectEnvironment } from 'planning-portal-library/src/lib/core/environments/environment.token';
import { map, mergeMap, Observable, reduce } from 'rxjs';
import {
  GetLocationLookupRequest,
  GetLookupRequest,
  LocationLookup,
  Lookup,
} from '../../../../core/domain';
import { LookupsRepository } from '../../../../core/repositories';
import { BaseResponse } from '../../../shared/base.response';
import { LocationLookupWebEntity } from './location-lookup-web-entity';
import { LocationLookupWebRepositoryMapper } from './location-lookup-web-repository-mapper';
import { LookupApiUrls } from './lookup-api-urls';
import { LookupWebEntity } from './lookup-web-entity';
import { LookupWebRepositoryMapper } from './lookup-web-repository-mapper';

@Injectable({ providedIn: 'root' })
export class LookupWebRepository extends LookupsRepository {
  private readonly lookupWebRepositoryMapper = new LookupWebRepositoryMapper();
  private readonly locationLookupWebRepositoryMapper =
    new LocationLookupWebRepositoryMapper();
  private readonly environment = injectEnvironment();

  constructor(private readonly http: HttpClient) {
    super();
  }

  getLookupLocations(
    request: GetLocationLookupRequest
  ): Observable<LocationLookup[]> {
    return this.http
      .post<BaseResponse<LocationLookupWebEntity[]>>(
        `${this.environment.url}${LookupApiUrls.GetLookupLocations}`,
        request
      )
      .pipe(
        mergeMap(
          (response: BaseResponse<LocationLookupWebEntity[]>) =>
            response.result!
        )
      )
      .pipe(map(this.locationLookupWebRepositoryMapper.mapFrom))
      .pipe(
        reduce(
          (items: LocationLookup[], item: LocationLookup) => [...items, item],
          []
        )
      );
  }

  getLookupPlan(request: GetLookupRequest): Observable<Lookup[]> {
    return this.http
      .post<BaseResponse<LookupWebEntity[]>>(
        `${this.environment.url}${LookupApiUrls.GetLookupPlans}`,
        request
      )
      .pipe(
        mergeMap(
          (response: BaseResponse<LookupWebEntity[]>) => response.result!
        )
      )
      .pipe(map(this.lookupWebRepositoryMapper.mapFrom))
      .pipe(reduce((items: Lookup[], item: Lookup) => [...items, item], []));
  }

  getLookupMasterPlan(request: GetLookupRequest): Observable<Lookup[]> {
    return this.http
      .post<BaseResponse<LookupWebEntity[]>>(
        `${this.environment.url}${LookupApiUrls.GetLookupMasterPlans}`,
        request
      )
      .pipe(
        mergeMap(
          (response: BaseResponse<LookupWebEntity[]>) => response.result!
        )
      )
      .pipe(map(this.lookupWebRepositoryMapper.mapFrom))
      .pipe(reduce((items: Lookup[], item: Lookup) => [...items, item], []));
  }

  getLookupJob(request: GetLookupRequest): Observable<Lookup[]> {
    return this.http
      .post<BaseResponse<LookupWebEntity[]>>(
        `${this.environment.url}${LookupApiUrls.GetLookupJobs}`,
        request
      )
      .pipe(
        mergeMap(
          (response: BaseResponse<LookupWebEntity[]>) => response.result!
        )
      )
      .pipe(map(this.lookupWebRepositoryMapper.mapFrom))
      .pipe(reduce((items: Lookup[], item: Lookup) => [...items, item], []));
  }
}
